// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__21fEi","name":"Header_name__2iOek","birthday":"Header_birthday__Lg0F8","skeleton":"Header_skeleton__38L_S"};